(function () {
  let ip = null;
  let ipPromise = null;

  window.getIp = function () {
    //Check if already retrieved and cached
    if (ip !== null) {
      return Promise.resolve(ip);
    }

    //Try sessionStorage cache first
    const cachedIp = sessionStorage.getItem("crt_ip");
    if (cachedIp) {
      ip = cachedIp;
      return Promise.resolve(ip);
    }

    //Fetch from API if not cached
    if (!ipPromise) {
      ipPromise = fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          ip = data.ip;
          sessionStorage.setItem("crt_ip", ip);
          return ip;
        })
        .catch(() => null);
    }

    return ipPromise;
  };

  //Fetch immediately on load (to be as fast as possible)
  ipPromise = getIp();
})();
